export default __webpack_public_path__ + "static/media/pause-menu.a7f2ebe7.png";